import * as React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

const TESTID = 'user-plus-stroke-svg';

export const UserPlusStrokeIcon = ({ fill = 'gcBlue', size = 'xsmall' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg
            data-testid={TESTID}
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 22 20"
        >
            <path
                className={fillStyles}
                d="M11 12.5C11.5523 12.5 12 12.9477 12 13.5C12 14.0523 11.5523 14.5 11 14.5L6.0498 14.501C4.80303 14.5052 4.45238 14.5308 4.12891 14.6289C3.17027 14.9198 2.41979 15.6702 2.12891 16.6289L2.0957 16.7539C2.02498 17.0547 2.00469 17.4594 2.00098 18.5498L2 19C2 19.5523 1.55228 20 1 20C0.447715 20 0 19.5523 0 19L0.00585938 17.8848C0.0205019 16.9069 0.0683475 16.5319 0.214844 16.0488C0.699601 14.4508 1.95078 13.1996 3.54883 12.7148L3.72656 12.665C4.28115 12.5191 4.8083 12.5 6.5 12.5H11ZM18 12C18.5523 12 19 12.4477 19 13V15H21C21.5523 15 22 15.4477 22 16C22 16.5523 21.5523 17 21 17H19V19C19 19.5523 18.5523 20 18 20C17.4477 20 17 19.5523 17 19V17H15C14.4477 17 14 16.5523 14 16C14 15.4477 14.4477 15 15 15H17V13C17 12.4477 17.4477 12 18 12ZM9 0C12.0376 0 14.5 2.46243 14.5 5.5C14.5 8.53757 12.0376 11 9 11C5.96244 11 3.5 8.53757 3.5 5.5C3.5 2.46244 5.96244 0 9 0ZM9 2C7.067 2 5.5 3.567 5.5 5.5C5.5 7.433 7.067 9 9 9C10.933 9 12.5 7.433 12.5 5.5C12.5 3.567 10.933 2 9 2Z"
            />
        </svg>
    );
};

UserPlusStrokeIcon.TEST_ID = TESTID;
